<template>
  <div class="budget-page">
    <div class="header-section">
      <video class="desktop" autoplay="autoplay" playsinline="" muted="" loop="loop" alt="gif" src="https://cdn.shopify.com/videos/c/o/v/680a27e4313e47cdbce0f534756b351e.mp4"></video>
      <video class="mobile" autoplay="autoplay" playsinline="" muted="" loop="loop" alt="gif" src="https://cdn.shopify.com/videos/c/o/v/4dbe17f6533a4d479d880b389f3d9346.mp4"></video> 
      <div class="text-container"> 
        <h2>Let them pick <br class="desktop"/> their perfect gift</h2>
        <p class="main-subtitle">Send a gift today or <br class="mobile"/> schedule it for later</p>
      </div>
      <button @click="() => {this.isWorking = true;}" class="h-button">How it Works</button>
    </div>
    <div class="top-section">
      <div class="main-container">
        <div class="n-container">
          <div class="n-header">
            <p class="legend">Step 1 (of 3)</p>
            <p class="main-title desktop"><span>They</span> pick their gift from the budget <span>you</span> select</p>
            <p class="main-title mobile">Select your budget</p>
            <div id="budget" class="budget-container">
              <button @click="() => {normalId = collection.id;}" :class="collection.id == normalId ? 'selected' : ''" class="happybox-button white border" v-for="collection in normalGOC" :key="collection.id">
                {{collection | moneyFloatFormat}}
                </button>
            </div>
            <p class="main-subtitle desktop">All prices include US shipping. Scroll to see gift options</p>
            <p class="main-subtitle mobile">All prices include US shipping.</p>
            <button @click="() => {this.isPreviewing = true;}" class="p-button">
              <img class="i" src="https://cdn.shopify.com/s/files/1/1363/8433/files/eye.svg?v=1731361910"/>
              Preview
            </button>
            <button id="topbudget" @click="selectTopGOC(selectedNormalGOC)" v-show="selectedNormalGOC" class="happybox-button green border">Step 2: Enter recipient information ></button>
            <a href="#budget" id="backtop" :class="!selectedNormalGOC ? 'hidden' : ''" class="happybox-button green border">Back to Budget Selection ^</a>
          </div>
          <div id="budgetProducts" v-if="selectedNormalGOC && selectedNormalGOC.collectionProducts && selectedNormalGOC.collectionProducts.length > 0" class="products-container">
            <div class="product-item" v-for="product in selectedCollectionProductsShown" :key="product.id">
              <p v-if="ethosTag(product)" class="main-badge" :class="badgeExtraClass(product)">{{ ethosTag(product) }}</p>
              <img @click="selectProduct(product)" class="i" src="https://cdn.shopify.com/s/files/1/1363/8433/files/information.svg?v=1731080982"/>
              <div class="image-container">
                <img @click="selectProduct(product)" class="lazyload" :src="product | getProductImage"/>
                <button @click="selectTopGOC(selectedNormalGOC)" class="happybox-button white border">Select {{selectedNormalGOC | moneyFloatFormat }} Collection</button>
              </div>
              <p class="product-title">{{ product.title }}</p>
            </div>
          </div>
          <div v-else class="spinner-container">
            <p>amazing gifts are loading...</p>
            <div class="spinner"></div>
          </div>
          <button id="show" class="show" v-if="selectedNormalGOC && selectedNormalGOC.collectionProducts && selectedNormalGOC.collectionProducts.length > 0" @click="changeShow()">
            {{ !showMore ? `Show More Gifts` : `Show Less Gifts` }}
          </button>
        </div>
        <div class="normal-container">
          <div class="title-header">
            <p class="title-container">
              <span class="title">Themed Collections</span>
              <span class="subtitle">We've curated the perfect assortment of products by occasion and budget.</span>
            </p>
            <div class="arrows-container">
              <img @click="$refs.featured.prev();" class="l-arrow" src="https://cdn.shopify.com/s/files/1/1363/8433/files/white_button_square.svg?v=1720472546" alt="left arrow"/>
              <img @click="$refs.featured.next();" class="r-arrow" src="https://cdn.shopify.com/s/files/1/1363/8433/files/white_button_square.svg?v=1720472546" alt="right arrow"/>
            </div>
          </div>
          <div class="collections-container" v-if="featuredGOC.length == 0">
            <FeaturedSkeleton v-for="n in skeletons" :key="n" />
          </div>
          <div v-else class="collections-container">
            <Flicking ref="featured" class="flicking-goc-collection" :plugins="plugins1" :options="{ align: 'prev', circular: true, preventDefaultOnDrag: true,preventClickOnDrag: true, panelsPerView: panels }">
              <FeaturedGOC @selectgoc="selectGoc" v-for="goc in featuredGOC" :goc="goc" :key="goc.id" />
              <FeaturedSkeleton v-if="isLoadingFeatured"/>
            </Flicking>
          </div>
        </div>
      </div>
    </div>
    <div class="middle-section">
      <div class="main-container">
        <div class="normal-container">
          <div class="title-header">
            <p class="title-container"><span class="title">Gifts that Ship Internationally</span><span class="subtitle">Your gift value includes shipping costs</span></p>
            <div class="arrows-container">
              <img @click="$refs.international.prev();" class="l-arrow" src="https://cdn.shopify.com/s/files/1/1363/8433/files/white_button_square.svg?v=1720472546" alt="left arrow"/>
              <img @click="$refs.international.next();" class="r-arrow" src="https://cdn.shopify.com/s/files/1/1363/8433/files/white_button_square.svg?v=1720472546" alt="right arrow"/>
            </div>
          </div>
          <div class="collections-container" v-if="isLoading">
            <SkeletonPlaceholder v-for="n in skeletons" :key="n" />
          </div>
          <div v-else class="collections-container">
            <Flicking ref="international" class="flicking-goc-collection" :plugins="plugins3" :options="{ align: 'prev', circular: true, preventDefaultOnDrag: true,preventClickOnDrag: true, panelsPerView: internationalPanels }">
              <NormalGOC @selectgoc="selectGoc" v-for="goc in intGOC" :goc="goc" :key="goc.id" />
              <NormalGOC @selectgoc="selectGoc" v-if="intGOC.length < 5" v-for="goc in intGOC" :goc="goc" :key="goc.id + 1" />
            </Flicking>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-section">
      <div class="how-it-works">
        <p class="title">Here's what each gift recipient will see.</p>
        <div class="instructions-container">
            <div class="instruction">
                <div class="main-image-container">
                    <img class="main-image lazyload" data-src="https://cdn.shopify.com/s/files/1/1363/8433/files/email_4b763acd-5294-41b7-82ae-7fd39d559e9f.png?v=1733435878" />
                </div>
                <p class="check">
                    <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/check_white.svg?v=1718978114"/>
                    <span class="desktop">They receive an email prompting <br/> them to select their gift & are <br/> reminded weekly for 30 days</span>
                    <span class="mobile">They receive an email prompting <br/> them to select their gift & are <br/> reminded weekly for 30 days</span>
                </p>
                <img class="m-arrow middle top" src="https://cdn.shopify.com/s/files/1/1363/8433/files/arrow_86d2a811-d7ca-41ff-b1ee-25044c4965e7.svg?v=1675281238" />
            </div>
            <div class="instruction">
                <div class="main-image-container">
                    <img class="main-image lazyload" data-src="https://cdn.shopify.com/s/files/1/1363/8433/files/time_to_pick_your_gift.png?v=1733435878"/>
                </div>
                <p class="check">
                    <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/check_white.svg?v=1718978114"/>
                    <span class="desktop">They enter their shipping address.</span>
                    <span class="mobile">They enter their <br/> shipping address.</span>
                </p>
                <img class="m-arrow middle bottom" src="https://cdn.shopify.com/s/files/1/1363/8433/files/arrow_86d2a811-d7ca-41ff-b1ee-25044c4965e7.svg?v=1675281238" />
            </div>
            <div class="instruction">
                <div class="main-image-container">
                    <img  class="main-image lazyload" data-src="https://cdn.shopify.com/s/files/1/1363/8433/files/gift_a8c259b9-a806-437a-ab38-2bf620194805.png?v=1733435878" />
                </div>
                <p class="check">
                    <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/check_white.svg?v=1718978114"/>
                    <span class="desktop">They get exactly what they <br/> want 1-2 weeks later</span>
                    <span class="mobile">They get exactly what they <br/> want 1-2 weeks later</span>
                </p>
            </div>
        </div>
      </div>
      <Inquire/>
      <FAQ/>
    </div>
    <div @click="() => {this.isWorking = false;}" class="hiw-outer" v-show="isWorking">
      <div v-on:click.stop class="hiw">
        <img @click="() => {this.isWorking = false;}" src="https://cdn.shopify.com/s/files/1/1363/8433/files/x_f565b23e-dc3f-4bd6-8843-442daa0e1434.svg?v=1719947652" class="x" alt="x"/>
        <p class="hiw-p">HOW IT WORKS</p>
        <img @click="$refs.hiwflicking.prev();" src="https://cdn.shopify.com/s/files/1/1363/8433/files/blue_left_arrow.svg?v=1720018496" class="arrow-left"/>
        <img @click="$refs.hiwflicking.next();" src="https://cdn.shopify.com/s/files/1/1363/8433/files/blue_right_arrow.svg?v=1720018497" class="arrow-right"/>
        <Flicking ref="hiwflicking" :options="{ align: 'prev', circular: true, preventDefaultOnDrag: true,preventClickOnDrag: true,renderOnlyVisible: true }">
          <div v-for="step of hiw" class="hiw-panel">
            <img class="lazyload" :src="step.img"/>
            <p class="subtitle"><strong>{{ step.title }}:</strong> {{ step.copy }}</p>
          </div>
        </Flicking>
      </div>
    </div>
    <ProductModal @closemodal="selectProduct(null)" :product="selectedProduct" v-if="selectedProduct"/>
    <div @click="() => {this.isPreviewing = false;}" v-if="selectedNormalGOC && isPreviewing" class="send-modal">
      <div v-on:click.stop class="internal no-scrollbar">
        <div class="preview-header">
          <p>You are currently viewing a preview</p>
          <img @click="() => {this.isPreviewing = false;}" src="https://cdn.shopify.com/s/files/1/1363/8433/files/x_f565b23e-dc3f-4bd6-8843-442daa0e1434.svg?v=1719947652" alt="x" class="x">
        </div>
        <TierMain @close="() => {this.isPreviewing = false;}" :collection="selectedNormalGOC"/>
      </div>
    </div>
    <div id="stickybudget">
      <button @click="selectTopGOC(selectedNormalGOC)" class="happybox-button green border">Next: Enter recipient information ></button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import FAQ from './Snippets/FAQ.vue';
import Inquire from './Snippets/Inquire.vue';
import ProductModal from './Snippets/ProductModal.vue'
import NormalGOC from './GOCComponents/NormalGOC.vue';
import FeaturedGOC from './GOCComponents/FeaturedGOC.vue';
import SkeletonPlaceholder from './Skeletons/NormalSkeleton.vue'
import FeaturedSkeleton from './Skeletons/FeaturedSkeleton.vue';
import Filters from './BudgetFilters/Filters.vue';
import TierMain from './GOCPreview/Tier/TierMain.vue';
import { AutoPlay, Arrow } from "@egjs/flicking-plugins";
export default {
  components:{
    FAQ,
    Inquire,
    NormalGOC,
    SkeletonPlaceholder,
    FeaturedSkeleton,
    FeaturedGOC,
    Filters,
    ProductModal,
    TierMain,
  },
  data(){
    return{
      hiw: [
        {
          title: "Step 1",
          copy: "Choose the collection of gifts they'll pick from. Shop by budget, theme, or ethos.",
          img: "https://cdn.shopify.com/s/files/1/1363/8433/files/gift_dc22db8c-3bfe-46b4-b674-a84f9db3d1e2.svg?v=1719844150"
        },
        {
          title: "Step 2",
          copy: "Add your recipients’ email address. Add one or many with an easy bulk upload.",
          img: "https://cdn.shopify.com/s/files/1/1363/8433/files/step_2.svg?v=1719844150"
        },
        {
          title: "Step 3",
          copy: "Customize your recipient’s gift experience – write your message, upload a logo & more!",
          img: "https://cdn.shopify.com/s/files/1/1363/8433/files/step_3.svg?v=1719844150"
        },
        {
          title: "Step 4",
          copy: "Create a Happy Box account to view analytics & track what they pick in real time.",
          img: "https://cdn.shopify.com/s/files/1/1363/8433/files/step_4_fda10d37-e468-4f3e-8430-9e4c90117fd2.svg?v=1720450911"
        }
      ],
      plugins1: [new AutoPlay({ duration: 3000, direction: "NEXT", stopOnHover: false })],
      plugins2: [new AutoPlay({ duration: 3000, direction: "NEXT", stopOnHover: false })],
      plugins3: [new AutoPlay({ duration: 3000, direction: "NEXT", stopOnHover: false })],
      isWorking: false,
      normalId: 8720928702629,
      selectedProduct: null,
      isPreviewing: false,
      showMore: false,
    }
  },
  computed:{
    ...mapGetters([
      'giftCollections',
      'selectedFilters'
    ]),
    isLoading(){
      if(!this.giftCollections || this.giftCollections.length == 0){
        return true
      }

      return false
    },
    intGOC(){
      if(this.giftCollections && this.giftCollections.length > 0){
        return this.giftCollections.filter(x => x.tags.find(y => y == "International"));
      }

      return [];
    },
    normalGOC(){
      if(this.giftCollections && this.giftCollections.length > 0){
        return this.giftCollections.filter(x => x.tags.every(y => y != "International" && y != "Featured"));
      }

      return [];
    },
    featuredGOC(){
      if(this.giftCollections && this.giftCollections.length > 0){
        let featuredCollections = this.giftCollections.filter(x => x.tags.find(y => y == "Featured") && x.category);
        if(featuredCollections.length > 0){
          const group = Object.groupBy(featuredCollections, ({ category }) => category);
          let arrays = Object.values(group);
          return arrays.map(x => x[0]);
        }
      }

      return [];
    },
    isLoadingFeatured(){
      if(this.giftCollections && this.giftCollections.length > 0){
        let featuredCollections = this.giftCollections.filter(x => x.tags.find(y => y == "Featured"));
        return featuredCollections.some(x => !x.category)
      }

      return true;
    },
    filteredGOC(){
      if(this.selectedFilters.length > 0){
        let filteredCollections =  JSON.parse(JSON.stringify(this.giftCollections));
        for(let filter of this.selectedFilters){
          filteredCollections = filteredCollections.filter(x => filter.filters.some(y => x.tags.includes(y)));
        }
        return filteredCollections;
      }

      return this.giftCollections;
    },
    isMobile() {
      return window.innerWidth < 768;
    },
    skeletons(){
      if(this.isMobile){
        return 1
      }
      else {
        return 4
      }
    },
    internationalPanels(){
      if(this.isMobile){
        return 1.5
      }
      else {
        return 4
      }
    },
    panels(){
      if(this.isMobile){
        return 1.5
      }
      else {
        return 4
      }
    },
    selectedNormalGOC(){
      if(this.normalGOC && this.normalGOC.length > 0){
        if(this.normalId){
          return this.normalGOC.find(x => x.id == this.normalId);
        }

        return this.normalGOC[0];
      }
    },
    selectedCollectionProductsShown(){
      if(this.selectedNormalGOC){
        if(this.showMore){
          return this.selectedNormalGOC.collectionProducts;
        }
        else 
          return this.selectedNormalGOC.collectionProducts.slice(0,20);
      }

      return [];
    }
  },
  methods:{
    selectTopGOC(event){
      window.scrollTo(0,0);
      this.$emit('selecttop',event);
    },
    selectGoc(event){
      window.scrollTo(0,0);
      this.$store.commit('setSelectedCollection', event );
    },
    selectProduct(product){
      this.selectedProduct = product;
    },
    ethosTag(product){
      if(product){
        var ethos = product.tags.filter(y => y.includes("Filter_Ethos"));
        if(ethos.length > 0){
          ethos = ethos.map((x) => {
          var currentEthos = x.replace("Filter_","").split("_")
          return currentEthos[1]
          })

          return ethos[0];
        }
      }

      return null
    },
    badgeExtraClass(product){
      switch(this.ethosTag(product)){
        case "Women Owned":
          return "pink";
        case "Small Biz":
          return "green"
        case "BIPOC Owned":
          return "yellow"
        case "Sustainable":
          return "dgreen"
        default:
          return '';
      }
    },
    changeShow(){
      const container = document.getElementById('budgetProducts');
      this.showMore = !this.showMore;
      if (!this.showMore) {
        this.$nextTick(() => {
          container.scrollIntoView({ behavior: 'smooth', block: 'end' });
        })
      }
    },
  },
  mounted(){
    const header = document.getElementById('topbudget');;
    const stickyHead = document.getElementById('backtop');

    const hOptions = {
      root: null,
      threshold: 0.8
    };


    const hObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        stickyHead.classList.toggle("isSticky", !entry.isIntersecting);
      });
    }, hOptions);

    hObserver.observe(header);
  },

}
</script>

<style>
  .flicking-goc-collection {
    min-width: 100%;
  }
  .flicking-goc-collection .flicking-camera{
    gap: 2%;
    padding: 1% 0%;
  }

  .hiw-panel{
    width: 100%;
    display: flex;
    align-items: center;
    min-height: 7vh;
  }

  .hiw-panel img{
    width: 10%;
    margin-right: 5%;
  }

  .hiw-panel .subtitle strong{
    text-transform: uppercase;
  }

  .hiw-panel .subtitle{
    width: 89%;
    font-size: 1.3vw;
    text-align: left;
    margin: unset;
    line-height: 1.2;
  }
</style>
<style scoped>
  #topbudget{
    display: none;
  }

  .header-section{
    width: 100%;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
  }

  .header-section picture{
    display: flex;
  }

  .header-section .header-image{
    width: 100%;
    margin: unset
  }

  .header-section video{
    width: 100%;
  }

  .header-section .text-container{
    position: absolute;
    left: 15%;
    top: 0;
    bottom: 0;
    width: 40%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    text-align: left;
  }

  .header-section h2{
    font-size: 4.5vw;
    line-height: .9;
    font-family: Founders Grotesk, sans-serif;
    font-weight: 300;
    margin: unset;
    margin-bottom: 1rem;
  }

  .header-section h2 span{
    font-style: italic;
  }

  .header-section .main-subtitle{
    font-size: 1.3vw;
    margin-bottom: 1rem;
  }

  .budget-page{
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .top-section{
    width: 100%;
    display: flex;
    flex-direction: row;
    background-color: #FFFDF9;
    padding-top: 2%;
  }

  .top-section .main-container,.middle-section .main-container{
    width: 100%;
    padding: 0% 5%;
  }

  .middle-section{
    width: 100%;
    display: flex;
    flex-direction: row;
    background-color: white;
  }

  .middle-section .main-container{
    padding-top: 2%;
  }

  .collection-list{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 3%;
  }

  .normal-container{
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 0% 0 5% 2%;
  }

  .normal-container .title-header{
    width: 100%;
    display: flex;
    padding-bottom: 2%;
    border-bottom: 1px solid lightgray;
    align-items: flex-end;
    justify-content: space-between;
    margin-bottom: 1rem;
  }

  .normal-container .title-header .title-container{
    max-width: 80%;
    border-bottom: unset;
    padding-bottom: unset;
    margin: unset;
  }

  .normal-container .title-header .arrows-container{
    display: flex;
    align-items: center;
    gap: 5%;
    min-width: 20%;
    justify-content: center;
  }

  .normal-container .title-header .arrows-container img{
    cursor: pointer;
    height: 3vw;
  }

  .normal-container .title-header .arrows-container .r-arrow{
    transform: rotate(180deg);
  }

  .normal-container .title-container{
    width: 100%;
    display: flex;
    padding-bottom: 2%;
    border-bottom: 1px solid lightgray;
    align-items: center;
    gap: 2%;
  }

  .normal-container .title-container .title{
    font-size: 2vw;
    line-height: 1;
    font-family: ff-more-web-pro-condensed, Karla, sans-serif;
    font-weight: 300;
  }

  .normal-container .title-container .subtitle{
    font-size: 1.15vw;
    line-height: 1;
  }

  .normal-container .title-container .legend{
    font-size: 1.15vw;
    line-height: 1;
    font-style: italic;
  }

  .collections-container{
    width: 100%;
    display: flex;
    gap: 2%;
  }

  .bottom-section{
		background-image: linear-gradient(#f0fdf7, #e7eaff);
    padding: 5%;
	}

  .hiw{
    width: 60%;
    box-shadow: 0px 0px 10px 2px rgba(0, 0, 0, 0.1);
    background-color: white;
    padding: 2% 10%;
    border-radius: 20px;
    position: relative;
  }

  .hiw-p{
    background-color: #ffd9c5;
    padding: 0.5% 1%;
    width: 15%;
    font-weight: 700;
    font-size: 1vw;
    border-radius: 8px;
    position: absolute;
    top: -10%;
    left: 40%;
    text-align: center;
  }

  .hiw .arrow-right{
    position: absolute;
    top: calc((100% - 20px) / 2);
    width: 20px; 
    right: 5%;
    cursor: pointer;
  }

  .hiw .arrow-left{
    position: absolute;
    top: calc((100% - 20px) / 2);
    width: 20px; 
    left: 5%;
    cursor: pointer;
  }


  .main-container .n-container .legend{
    font-size: 1.3vw;
    font-weight: bold;
  }

  .main-container .n-container .main-title{
    font-size: 3vw;
    line-height: 1;
    font-family: 'ff-more-web-pro-condensed';
    margin-bottom: 1.5rem;
  }

  .main-container .n-container .main-title span{
    font-style: italic;
  }

  .main-container .n-container .main-subtitle{
    font-size: 1vw;
  }

  .main-container .n-container .n-header > .happybox-button{
    padding: 1% 10%;
    margin-bottom: 1rem;
  }

  .hiw-outer{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: rgba(0,0,0,0.3);
    position: fixed;
    height: 100%;
    z-index: 999;
    top: 0;
    right: 0;
    left: 0;
  }

  .hiw-outer .x{
    width: 3%;
    position: absolute;
    top: 5%;
    right: 1%;
  }

  .h-button{
    background-color: white;
    font-size: 1vw;
    padding: 0.3rem 0.6rem;
    border-radius: 4px;
    font-weight: 900;
    color: #0f0c38;
    border: 1px solid #0f0c38;
    text-transform: uppercase;
    position: absolute;
    bottom: 2%;
    right: 0.5%;
  }

  .h-button:hover,.p-button:hover{
    background-color: #5cffc0;
  }

  .n-header{
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .p-button{
    background-color: white;
    font-size: 1vw;
    padding: 0.3rem 0.6rem;
    border-radius: 8px;
    font-weight: 900;
    color: #0f0c38;
    border: 1.5px solid #0f0c38;
    text-transform: uppercase;
    position: absolute;
    bottom: 5%;
    right: 0%;
    display: flex;
    flex-direction: row;
    gap: 5px;
    align-items: center;
  }

  .p-button img{
    width: 20px;
  }

  .budget-container{
    display: flex;
    align-items: center;
    gap: 20px;
    margin-bottom: 0.5rem;
    width: 80%;
  }

  .budget-container .happybox-button{
    padding: 1% 0%;
    flex: 1;
  }

  .budget-container .happybox-button.selected{
    background-color: #0F0C38;
    color: white;
  }

  .n-container{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .products-container{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    gap: 2%;
    padding-top: 1rem;
    border-top: 1px solid lightgray;
    position: relative;
  }

  .product-item{
    width: 23%;
    border: 1px solid #e0e0e0;
    padding: 2%;
    display: flex;
    flex-direction: column;
    margin-bottom: 2%;
    background-color: white;
    border-radius: 8px;
    position: relative;
  }

  .product-item img{
    width: 100%;
  }

  .product-item .i{
    position: absolute;
    width: 8%;
    z-index: 1;
    right: 5%;
    top: 5%;
    cursor: pointer;
  }

  .product-item .image-container{
    width: 100%;
    margin-bottom: 5%;
    position: relative;
    overflow: hidden;
    cursor: pointer;
  }

  .product-item .happybox-button{
    position: absolute;
    width: 90%;
    bottom: -30%;
    margin: unset;
    transition: all 0.5s ease-in-out;
    left: 5%;
    padding: 2%;
  }

  .product-item .image-container:hover .happybox-button{
    bottom: 10%;
    z-index: 1;
  }

  .product-title {
    font-size: 1.15vw;
    font-weight: 700;
    margin: unset;
  }

  .main-badge {
    background-color: #fff;
    position: absolute;
    top: 2%;
    left: 2%;
    border: 1px solid #F3EEFA;
    box-sizing: border-box;
    border-radius: 4px;
    padding: 1% 3%;
    font-size: 1.1vw;
    font-weight: 700;
    color: #5981d9;
    z-index: 1;
  }

  .main-badge.pink{
    background-color: #fbdaff;
  }

  .main-badge.dgreen{
    background-color: #a9ffbd;
  }

  .main-badge.green {
    background-color: #d8efdf;
  }

  .send-modal{
    position: fixed;
    top: 90px;
    bottom: 0;
    right: 0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 2;
  }

    .send-modal .internal{
      width: 90%;
      height: auto;
      background-color: white;
      border-radius: 8px;
      border: 1px solid lightgray;
      max-height: 90%;
      overflow-y: scroll;
      position: relative
    }

    .send-modal .internal .preview-header{
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 1% 2%;
      position: sticky;
      top: 0;
      z-index: 7;
      background-color: white;
      height: 40px;
    }

    .send-modal .internal .preview-header img{
      width: 25px;
    }


    .show{
      width: 100%;
      color: #A01ADB;
      text-decoration: underline;
      font-weight: bold;
      font-size: 1.5vw;
      padding: 2% 5%;
      display: none;
    }

    #backtop{
      display: none;
    }

    #stickybudget{
      position: fixed;
      left: 0%;
      width: 100%;
      bottom: 0%;
      z-index: 3;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 1% 0;
      background-color: #FFFD;
    }

    #stickybudget .happybox-button{
      padding: 1% 3%;
    }

    .how-it-works{
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 0% 10% 5%;
    }

    .how-it-works .title{
      font-size: 3vw;
      line-height: 1;
      font-family: ff-more-web-pro-condensed;
      text-align: center;
      color: #0f0c38;
      padding: 5% 0%;
      margin: unset;
    }

    .happy-choice .title{
      font-family: "moret";
      font-size: 4vw;
      font-weight: bold;
      line-height: 1;
      text-align: center;
      color: #0f0c38;
      padding-bottom: 5%;
      margin: unset;
    }

    .instructions-container{
      width: 100%;
      display: flex;
      justify-content: space-between;
    }

    .instruction{
        width: 30%;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        position: relative;
        align-items: center;
    }

    .instruction .m-arrow{
        position: absolute;
        width: 25%;
    }

    .instruction .m-arrow.middle{
      top: 40%;
      right: -15%;
    }

    .instruction .main-image-container{
        width: 100%;
        height: 87%;
        display: flex;
        align-items: center;
    }

    .instruction .main-image-container img{
        width: 100%;

    }

    .instruction .check{
        margin-bottom: 2%;
        font-size: 1.15vw;
        line-height: 1.2;
        display: flex;
        align-items: flex-start;
        color: #0f0c38;
        gap: 10px;
        height: 13%;
        margin-top: 5%;
        justify-content: center;
        width: 90%;
    }

    .instruction .check img{
        width: 6%;
    }
    @media screen and (min-width: 768px) {
      .header-section video{
        aspect-ratio: 5 / 1;
        object-fit: cover;
      }
    }

  @media screen and (max-width: 767px) {

    .header-section h2{
      font-size: 12vw;
      margin-bottom: 1rem;
    }

    .header-section .main-subtitle{
      font-size: 3.5vw;
      line-height: 1.2;
      margin-bottom: 0;
    }

    .hiw{
      padding: 5% 15%;
    }

    .hiw-panel img {
      width: 15%;
    }

    .hiw-p{
      font-size: 3vw;
      width: 30%;
      left: 35%;
    }

    .hiw-panel .subtitle{
      font-size: 3vw;
      width: 80%;
    }

    .hiw{
      width: 90%;
    }
    .hiw-panel{
      justify-content: center;
    }

    .top-section .main-container{
      width: 100%;
      padding: 0% 5%;
    }
    .main-container .n-container .main-title{
      font-size: 8vw;
      text-align: center;
    }

    .main-container .n-container .legend{
      font-size: 3.5vw;
    }

    .normal-container{
      padding: 0% 0 5% 2%;
    }

    .normal-container .title-container{
      flex-direction: column;
      align-items: flex-start;
    }

    .normal-container .title-container .title{
      font-family: 'Karla', sans-serif;
      font-weight: bold;
      font-size: 4vw;
      margin-bottom: 0.5rem;
    }

    .normal-container .title-container .subtitle, .normal-container .title-container .legend{
      font-size: 3.5vw;
      line-height: 1.2;
    }

    .collections-container{
      width: 100vw;
      margin-left: -7vw;
    }

    .normal-container .title-header .arrows-container img{
      height: 5vh;
    }

    .header-section .text-container{
      top: unset;
      width: 55%;
      bottom: 10%;
      text-align: left;
      left: 5%;
    }

    .h-button{
      font-size: 2.5vw;
      bottom: 3%;
      right: 2%;
    }

    .hiw-outer .x{
      width: 6%;
      right: 3%;
    }

    .main-badge{
      font-size: 3vw;
    }

    .product-item{
      width: 48%;
    }

    .product-title{
      font-size: 3.5vw;
    }

    .main-container .n-container .budget-container .main-title{
      font-size: 7vw;
    }

    .product-item .happybox-button{
      display: none;
    }

    .product-item .i{
      width: 10%;
    }

    .show{
      padding-bottom: 3rem;
      font-size: 3.5vw;
    }

    #backtop.hidden{
      display: none !important;
    }

    #budgetselector{
      min-width: 90px;
    }

    .p-button{
      font-size: 3vw;
      position: fixed;
      right: 5%;
      z-index: 2;
      bottom: 10%;
    }

    .how-it-works .title{
        font-size: 8vw;
        width: 90%;
        line-height: 1.2;
    }

    .instructions-container{
        flex-direction: column;
    }

    .instruction{
        width: 100%;
        align-items: center;
        margin-bottom: 10%;
    }

    .instruction .check{
        flex-direction: column;
        align-items: center;
        height: unset;
        font-size: 4vw;
        text-align: center;
    }

    .instruction .check img{
        width: 10%;
    }


    .instruction .arrow.middle.top{
        top: unset;
        bottom: 20%;
        right: 0%;
        transform: rotatez(90deg);
    }

    .instruction .arrow.middle.bottom{
        top: unset;
        bottom: 5%;
        left: 0%;
        right: unset;
        transform: rotatez(90deg) rotateX(180deg);
    }

    .budget-container{
      width: 100%;
      gap: 10px;
    }

    #stickybudget{
      padding: 5% 0;
    }

    .main-container .n-container .main-subtitle{
      font-size: 3vw;
    }

    #stickybudget .happybox-button{
      padding: 2% 10%;
    }

    .instruction .m-arrow{
      position: initial;
      transform: rotate(90deg);
      margin: 2rem 0 1rem;
    }
  }

</style>